import { COUNT_STATISTICS_DATA_TYPE } from 'StatisticsModule/constants';
import useCountStatisticalDashboard from 'hooks/useCountStatisticalDashboard';
import { TeamId } from 'IntegrationModule/types';
import { Box } from '@mui/material';
import DashboardFilters from 'StatisticsModule/components/CountStatistics/DashboardFilters';
import { useEffect } from 'react';

const dataTypeToIgnoreSet = new Set([COUNT_STATISTICS_DATA_TYPE.TEAMS]);

type TeamsOverviewContainerProps = {
  teamId: TeamId;
};

export const TeamsOverviewContainer: React.FC<TeamsOverviewContainerProps> = ({ teamId }) => {
  const {
    triggerCountStatisticsFilter,
    Dashboard,
    onSelectSearchRangeDate,
    onSelectTeamCreationDate,
    teamCreationDateOption,
    selectedSearchDateRange,
    onSelectCustomSearchRange,
    tempCustomEnd,
    tempCustomStart,
  } = useCountStatisticalDashboard({
    teamIds: [teamId],
    shouldUseTeamCreationBounds: false,
    dataTypeToIgnoreSet,
  });

  useEffect(() => {
    if (teamId) {
      triggerCountStatisticsFilter({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamId]);

  return (
    <Box padding={4}>
      <DashboardFilters
        isLoading={false}
        teamCreationDateOption={teamCreationDateOption}
        onSelectSearchRangeDate={onSelectSearchRangeDate}
        onSelectTeamCreationDate={onSelectTeamCreationDate}
        shouldUseTeamCreationBounds={false}
        selectedSearchDateRange={selectedSearchDateRange}
        onSelectCustomSearchRange={onSelectCustomSearchRange}
        tempCustomEnd={tempCustomEnd}
        tempCustomStart={tempCustomStart}
        triggerCountStatisticsFilter={triggerCountStatisticsFilter}
      />
      {Dashboard}
    </Box>
  );
};
